import { FC, useMemo } from 'react';
import DashboardOverview from '../components/dashboard/overview/DashboardOverview';
import InsightsErrorBoundary from '../components/common/InsightsErrorBoundary';
import { FiCompass } from 'react-icons/fi';
import { motion } from 'framer-motion';

const InsightsDashboard: FC = () => {
  // Dynamic date label — derived from current date (matches metric_date in API response)
  const dateLabel = useMemo(() => {
    const now = new Date();
    return now.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }, []);

  return (
    <div style={{ backgroundColor: '#EAEDF4' }}>
      {/* Main content */}
      <main className="max-w-7xl mx-auto px-3 sm:px-4 py-4 sm:py-6 pb-20 sm:pb-24">
        {/* Page title matching Members Details Tab style */}
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="mb-6"
        >
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-700 mb-2">VeraScore Insights</h1>
          <p className="text-sm sm:text-base text-slate-500">
            Empowering you through data-driven decisions
          </p>
        </motion.div>
        
        {/* Content Container with clean white styling matching Members Details Tab */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="bg-white rounded-lg shadow-sm p-4 sm:p-6 mt-0"
        >
          {/* Header with clean styling matching Members Details Tab */}
          <div className="mb-4 sm:mb-6 border-b border-slate-200 pb-4 sm:pb-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-slate-100 flex items-center justify-center mr-3">
                  <span className="text-slate-600">
                    <FiCompass size={16} />
                  </span>
                </div>
                <div>
                  <h2 className="text-xl sm:text-2xl font-bold text-slate-700">
                    Strategic Guidance
                  </h2>
                  <p className="text-sm sm:text-base text-slate-500">
                    Insights and recommendations for strategic decisions
                  </p>
                </div>
              </div>
              <div className="text-sm text-slate-500">
                Showing Insights as of: {dateLabel}
              </div>
            </div>
          </div>
          
          {/* Content area with clean white background */}
          <div className="bg-white">
            <InsightsErrorBoundary section="Insights">
              <DashboardOverview />
            </InsightsErrorBoundary>
          </div>
        </motion.div>
      </main>
    </div>
  );
};

export default InsightsDashboard;
